var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    !_vm.showCustomMessage
      ? _c("div", { staticClass: "modal-body-text" }, [
          _vm._v("You are requesting to change "),
          _c("span", { staticClass: "modal-event-name" }, [
            _vm._v(_vm._s(_vm.itemName))
          ]),
          _vm._v(" after it's been approved. Upon submitting, you agree:")
        ])
      : _vm._e(),
    _vm._v(" "),
    !_vm.showCustomMessage
      ? _c("div", [
          _vm._m(0),
          _vm._v(" "),
          _c("div", { staticClass: "modal-body-text modal-body-text-li" }, [
            _vm._v(
              "Continuing to the next screen to change your event will NOT charge you. Submitting your changes will."
            )
          ])
        ])
      : _c(
          "div",
          {
            staticClass: "custom-message modal-body-text",
            domProps: { innerHTML: _vm._s(_vm.customMessage) }
          },
          [_vm._v(_vm._s(_vm.customMessage))]
        )
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("ul", [
      _c("li", { staticClass: "modal-body-text modal-body-text-li" }, [
        _vm._v(
          "To accept your request to change the event must go through approval again"
        )
      ]),
      _vm._v(" "),
      _c("li", { staticClass: "modal-body-text modal-body-text-li" }, [
        _vm._v(
          "That we cannot guarantee your event will be approved for your requested change"
        )
      ]),
      _vm._v(" "),
      _c("li", { staticClass: "modal-body-text modal-body-text-li" }, [
        _vm._v(
          "\n          To pay the fee associated with your contract with ADURO (review for details)\n        "
        )
      ])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-b9626dbc", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-b9626dbc","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/modal/ChangeOrder.vue
// module id = 1365
// module chunks = 1